import React from 'react'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'
import { getPageUrl } from 'app/modules/shared/routing'
import { trackEvent } from 'app/modules/shared/helpers'
import AppbarDropdown from './appbar-dropdown'
import { getActiveSubRouteClass } from './helpers/helpers'

export const AETHER_ROUTE = 'upgrade-to-metadefender-aether'
const METADEFENDER_CLOUD_URL = 'https://metadefender.com'

// Shared with the More dropdown, so both menus always list the same links.
export const useEnterpriseItems = (): JSX.Element[] => {
  const { _t } = useTypedTranslation()
  const currentRoute = useLocation().pathname.substring(1)

  return [
    <Link
      key={AETHER_ROUTE}
      className={`dropdown-item ${getActiveSubRouteClass([AETHER_ROUTE], currentRoute, 'appbar-dropdown-item-selected')}`}
      to={getPageUrl('aether-upgrade') as string}
      onClick={() => trackEvent({ event: 'aether_upgrade_cta', cta_source: 'appbar-enterprise' })}
    >
      {_t('metadefender-aether')}
    </Link>,
    <a
      key={METADEFENDER_CLOUD_URL}
      className="dropdown-item"
      href={METADEFENDER_CLOUD_URL}
      target="_blank"
      rel="noreferrer"
    >
      {_t('metadefender-cloud')}
    </a>,
  ]
}

// Commercial product entry points (Aether upgrade, MetaDefender Cloud) in one
// dropdown, kept apart from the community items.
const Enterprise = (): JSX.Element => {
  const { _t } = useTypedTranslation()
  const currentRoute = useLocation().pathname.substring(1)
  const items = useEnterpriseItems()

  return (
    <AppbarDropdown
      className={`appbar-hide-medium ${getActiveSubRouteClass([AETHER_ROUTE], currentRoute, 'appbar-dropdown-selected')}`}
      title={_t('enterprise')}
    >
      {items}
    </AppbarDropdown>
  )
}

export default Enterprise
